module.exports = new __parcel__URL__("loading.3dc38d80.gif").toString();